import { Component } from '@angular/core'
import { AnimationOptions } from 'ngx-lottie'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'MopTax'
}
